import db from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import Main from './app/Main';

export default function App() {

  const [appData, setData] = useState(null);
  localStorage.clear();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docSnap = await getDoc(doc(db, "app", "app"));
        if (docSnap.exists()) {
          setData(docSnap.data());
          window.appData = docSnap.data();
          //console.log(window.appData);
        } else {
          console.log('Error fetching data: no such document');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  //loads screen only after appData is fetched
  return appData ? <Main /> : null;
}
